export default __webpack_public_path__ + "static/media/Layer2.6eafad88.png";